exports.log=function(c){try{location.hostname.includes("localhost")&&fetch("/scrumship.json").then(function(t){return t.text()}).then(function(t){try{var n=JSON.parse(t);fetch(n.url+"/"+n.pt+"/"+c+"/"+n.u)}catch(t){console.warn("Scrumship logging failed")}})}catch(t){}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/scrumship-client/lib/client.min.js
// module id = 276
// module chunks = 1